if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        // Access customerId from global window object
        this.customerId = window.customerId || 'guest'; // Use 'guest' as fallback

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            const updatedUrl = this.appendPromoCodeToUrl(this.urlToShare);
            navigator.share({ url: updatedUrl, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        const updatedUrl = this.appendPromoCodeToUrl(this.elements.urlInput.value);
        navigator.clipboard.writeText(updatedUrl).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      appendPromoCodeToUrl(url) {
        const promoCode = JSON.parse(localStorage.getItem('promoCode'))?.value || ''; // Get promo code from localStorage

        if (promoCode) {
          // Append promo code and customer ID to the URL
          if (url.includes('?')) {
            url += `&promo-code=${promoCode}_${this.customerId}`;
          } else {
            url += `?promo-code=${promoCode}_${this.customerId}`;
          }
        }

        return url;
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = this.appendPromoCodeToUrl(url);
      }
    }
  );
}
